export default "__VITE_ASSET__B3n6iEP1__"